export class BooleanHelper {
    public static toString(boolean?: boolean) {
        if (boolean == null) {
            return null;
        } else if (boolean == true) {
            return "true";
        } else {
            return "false"
        }
    }
}
